export default {
    
    indexDynamicAttributionResults: { method: 'get',    url: 'dynamic_attribution_results' },
    createDynamicAttributionResult: { method: 'post',   url: 'dynamic_attribution_results'},
    updateDynamicAttributionResult: { method: 'put',    url: 'dynamic_attribution_results/{id}'},
    deleteDynamicAttributionResult: { method: 'delete', url: 'dynamic_attribution_results/{id}'},
    showDynamicAttributionResults:  { method: 'get',    url: 'dynamic_attribution_results/{id}' },
    
}